export const LEAD_EMAIL_KEY = 'lead_email'

export const setLeadEmail = (email: string) => {
  localStorage.setItem(LEAD_EMAIL_KEY, email)

  const event = new Event('leadEmailSubmitted')
  document.dispatchEvent(event)
}

export const getLeadEmail = () => window.localStorage.getItem(LEAD_EMAIL_KEY)
